<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section *ngIf="modalInfo">
  <div (keyup)="onKeyUp($event)"
       aria-describedby="modal-content-01"
       aria-labelledby="modal-heading-01"
       aria-modal="true"
       class="slds-modal slds-fade-in-open"
       role="dialog"
       style="z-index: 9900"
       tabindex="-1">
    <div class="slds-modal__container">
      <header class="slds-modal__header">
        <button (click)="onCancel()"
                class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
                i18n-title
                id="modal-close" title="Cancel" type="button">
          <svg aria-hidden="true"
               class="slds-button__icon slds-button__icon_large">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
          </svg>
          <span class="slds-assistive-text" i18n>Close</span>
        </button>
        <h2 class="slds-text-heading_medium slds-hyphenate"
            id="modal-heading-01">
          <svg aria-hidden="true" class="slds-icon slds-icon_small slds-icon-text-light">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#question"></use>
          </svg>
          <span class="slds-m-left_small" id="modal-title">{{ modalInfo.title }}</span>
        </h2>
      </header>

      <div class="slds-modal__content slds-p-around_medium"
           id="modal-content-01">
        <div>
          <p *ngFor="let m of modalInfo.messages; let i = index"
             [id]="'modal-message-' + i">{{m}}</p>
        </div>
        <ng-content></ng-content>
      </div>

      <footer class="slds-modal__footer slds-modal__footer_directional">
        <button (click)="onCancel()"
                *ngIf="modalInfo.showCancel"
                [name]="modalInfo.cancelName"
                class="slds-button slds-button_neutral"
                id="modal-cancel" type="button">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
          </svg>
          <span>{{modalInfo.cancelLabel}}</span>
        </button>
        <button (click)="onNo()"
                [attr.autofocus]="modalInfo.yesIsDestructive"
                [name]="modalInfo.noName"
                class="slds-button slds-button_neutral"
                id="modal-no" type="button">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#error"></use>
          </svg>
          <span>{{modalInfo.noLabel}}</span>
        </button>
        <button (click)="onYes()"
                [attr.autofocus]="!modalInfo.yesIsDestructive"
                [name]="modalInfo.yesName"
                [ngClass]="modalInfo.yesClass"
                id="modal-yes" type="button">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
          </svg>
          <span>{{modalInfo.yesLabel}}</span>
        </button>
      </footer>
    </div>
  </div>
  <div class="slds-backdrop slds-backdrop_open"></div>
</section>
